export const environment = {
  production: true,

  /* Fetching environment variables - hardcoded url to fetch variables one time before app loads */
  /* Change tenant-name as per your requirements */
   application_id: 'neologger',
   config_fetch_env: 'neoLoggerProd',
   project: {
     name: 'Your Project Name',
     description: 'Your Project Description'
   },
  // graphql variables
  //AWS
  //graphql_url: 'https://graphql.dev-neo.bcone.com/',
  //Azure
  //graphql_url: 'https://graphql.dev.bristleconeneo.net/',
  //GCP
  graphql_url: 'https://graphql.dev.bconeneo.com/',
  trustSSOArn: '',
  platform_graphql_url: 'https://graphql.platformdev-neo.bcone.com/',

  /* cognito variables */
  pool_id: '',
  client_id: '',
  region: '',

  /* Identity Management console URL */
  neo_idm_url: '',

  api_url: '',
};
